// extracted by mini-css-extract-plugin
module.exports = {"title":"content-module--title--1X0Cm","position":"content-module--position--x-fHx","content":"content-module--content--tOzjJ"};